export enum MarksSide {
	None = 0,
	Left = -1,
	Right = 1,
}
